import { useStyles } from "./ShopAllInventory.style";
import { Button, Typography, TypographyVariant } from "@onmo/ui";
import {
  Inventory,
  InventoryAvatarData,
  InventoryStatus,
  meGQL,
} from "@onmo/graphql/graphql";
import ShopAvatar from "../../core/ShopAvatar/ShopAvatar";
import ShopBundle from "../../core/ShopBundle/ShopBundle";
import {
  useFetchAvatarsInventory,
  useFetchBundlesInventory,
  useFetchOwnedInventory,
} from "../../../hooks/resolvers/useShopQuery";
import { useAppDispatch } from "../../../hooks";
import { setOpenBundle } from "../../../slices/shop";
import { useQuery } from "@apollo/client";
import ShopAvatarLoading from "../../core/ShopAvatar/ShopAvatarLoading";
import { useTranslation } from "react-i18next";

type IShopAllInventoryProps = {
  setActiveTab: (tab: string) => void;
};

const ShopAllInventory: React.FC<IShopAllInventoryProps> = (props) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { setActiveTab } = props;
  const { ownedInventory } = useFetchOwnedInventory();
  const { bundlesInventoryAvailable } = useFetchBundlesInventory();
  const { avatarsInventory } = useFetchAvatarsInventory();
  const { data: dataMe } = useQuery(meGQL);
  const listAvatar = avatarsInventory?.filter(
    (item: Inventory) =>
      !item.isPurchased && item.status === InventoryStatus.Available,
  );

  return (
    <>
      {(!ownedInventory || !!ownedInventory?.length) && (
        <div className={classes.tabContent}>
          <div className={classes.tabTitle}>
            <Typography variant={TypographyVariant.HeadingH6Bold}>
              {t("shop_owned")}
            </Typography>
            <Button
              size="small"
              variant="borderless"
              icon="icon-bold-arrow-right-3"
              onClick={() => setActiveTab("Owned")}
            >
              {t("view_all")}
            </Button>
          </div>
          <div className={classes.listInventories}>
            {!ownedInventory
              ? Array.from(new Array(5)).map((_, idx) => (
                  <ShopAvatarLoading key={idx} />
                ))
              : ownedInventory?.map((item: Inventory) => {
                  return (
                    <ShopAvatar
                      inventory={item}
                      isUsing={
                        (item?.data as InventoryAvatarData).url ===
                        dataMe?.me.avatar
                      }
                    />
                  );
                })}
          </div>
        </div>
      )}
      {(!bundlesInventoryAvailable || !!bundlesInventoryAvailable?.length) && (
        <div className={classes.tabContent}>
          <div className={classes.tabTitle}>
            <Typography variant={TypographyVariant.HeadingH6Bold}>
              {t("shop_bundles")}
            </Typography>
            <Button
              size="small"
              variant="borderless"
              icon="icon-bold-arrow-right-3"
              onClick={() => setActiveTab("Bundles")}
            >
              {t("view_all")}
            </Button>
          </div>
          <div className={classes.listInventories}>
            {bundlesInventoryAvailable?.map((item: Inventory) => {
              return (
                <ShopBundle
                  inventory={item}
                  onClick={() => dispatch(setOpenBundle({ openBundle: item }))}
                />
              );
            })}
          </div>
        </div>
      )}
      {(!listAvatar || !!listAvatar?.length) && (
        <div className={classes.tabContent}>
          <div className={classes.tabTitle}>
            <Typography variant={TypographyVariant.HeadingH6Bold}>
              {t("shop_avatars")}
            </Typography>
            <Button
              size="small"
              variant="borderless"
              icon="icon-bold-arrow-right-3"
              onClick={() => setActiveTab("Avatars")}
            >
              {t("view_all")}
            </Button>
          </div>
          <div className={classes.listAvatars}>
            {!ownedInventory
              ? Array.from(new Array(5)).map((_, idx) => (
                  <ShopAvatarLoading key={idx} />
                ))
              : listAvatar?.map((item: Inventory) => {
                  if (item.isPurchased) return null;
                  return (
                    <ShopAvatar
                      inventory={item}
                      isUsing={
                        (item?.data as InventoryAvatarData).url ===
                        dataMe?.me.avatar
                      }
                    />
                  );
                })}
          </div>
        </div>
      )}
    </>
  );
};
export default ShopAllInventory;
